import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import Envelope from '@factorialco/f0-react/icons/app/Envelope'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { ResourceAction } from 'modules/marketplace_modules/components/Revamp/types'
import { useCreateEmailModuleRequest } from 'modules/marketplace_modules/hooks/useCreateEmailModuleRequest'

interface ResourcesProps {
  resources: ResourceAction[]
  module?: string
  pageSource?: string
  isAuthorized?: boolean
  moduleSlug?: string
}

const Resources: React.FC<ResourcesProps> = ({ resources, moduleSlug, module }) => {
  const { create: createEmailRequest } = useCreateEmailModuleRequest()
  if (resources?.length === 0) return null

  const handleSendEmail = async () => {
    try {
      await createEmailRequest({
        moduleName: module || '',
      })
      app.setFlash({
        type: 'correct',
        message: i18n.t('upselling_kit.button.email_sent'),
      })
      track(trackingEvents.upsellingKit.sendEmail, {
        source: 'marketplace_resources_send_email',
        module: module,
        component: 'product_modal',
      })
    } catch (error) {}
  }

  return (
    <Box flexDirection="column" gap="s8">
      <Text size="200" weight="medium">
        <span className="text-f1-foreground-secondary">
          {i18n.t('marketplace.revamp.more_resources')}
        </span>
      </Text>
      <Box flexDirection="column" gap="s8">
        {resources.map((resource) => {
          if (!resource.label) return null
          return (
            <Box key={resource.id} style={{ display: 'inline-block' }}>
              <F0Button
                size="sm"
                id={resource.id}
                label={resource.label}
                icon={resource.icon}
                onClick={resource.onClick}
                disabled={resource.disabled}
                variant="ghost"
              />
            </Box>
          )
        })}
        {moduleSlug && (
          <Box style={{ display: 'inline-block' }}>
            <F0Button
              size="sm"
              label={i18n.t('upselling_kit.button.send_email')}
              variant="ghost"
              onClick={handleSendEmail}
              icon={Envelope}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Resources
